
export class ProjectsListItemPagingModel {

    pagination: ProjectsListItemPaginationModel;
    data: ProjectsListItemModel[];

}


export class ProjectsListItemPaginationModel {
    currentPage: number;
    pageSize: number;
    totalCount: number;
    orderBy: ProjectsListItemOrderByModel;

}
export class ProjectsListItemOrderByModel {
    orderByColumn: string;
    orderDirection: string;

}

export class ProjectsListItemModel {
    id: number;
    status: string; // ProjectStatusEnum;
    statusDetails: string; // ProjectStatusDetailsEnum;
    priceApprovalStatus: string; // PriceApprovalStatusEnum;
    priceApprovalComment: string;
    name: string;
    companyName: string;
    companyZip: string;
    companyCity: string;
    requestedProductsTotalCount: number;
    validityOfQuotation: Date;
    rolloutStart: Date;
    rolloutEnd: Date;
    quoteGenerationType: string; // QuoteGenerationTypeEnum;
    isLocked: boolean;

    lockedByUserId: number;
    lockedBy: string;
    lockedByUserType: string; // UserTypeEnum;


    lastUpdateBy: string;
    lastUpdated: Date;  //  for statusBar right top corner

    devices: {  // for row hover table
        count: number, modelNumber: string, modelTitle: string
    }[];

    edited: boolean;
    quotesAvailable: boolean;


    referenceNo: string; // necessary for project list hover functionality for internal user

    isCreatedByBrotherEmployee: boolean;


    public static fromJson(projectsListItem: any): ProjectsListItemModel {
        if ( projectsListItem ) {
            if (projectsListItem.rolloutStart && typeof projectsListItem.rolloutStart === 'string') {
                projectsListItem.rolloutStart = new Date(projectsListItem.rolloutStart);
            }
            if (projectsListItem.rolloutEnd && typeof projectsListItem.rolloutEnd === 'string') {
                projectsListItem.rolloutEnd = new Date(projectsListItem.rolloutEnd);
            }

            if (projectsListItem.lastUpdated && typeof projectsListItem.lastUpdated === 'string') {
                projectsListItem.lastUpdated = new Date(projectsListItem.lastUpdated);
            }
            if (projectsListItem.validityOfQuotation && typeof projectsListItem.validityOfQuotation === 'string') {
                projectsListItem.validityOfQuotation = new Date(projectsListItem.validityOfQuotation);
            }
        }


        return projectsListItem as ProjectsListItemModel;
    }


}
